import { render, staticRenderFns } from "./ContainerManagement.vue?vue&type=template&id=56d8897b"
import script from "./ContainerManagement.vue?vue&type=script&lang=js"
export * from "./ContainerManagement.vue?vue&type=script&lang=js"
import style0 from "./ContainerManagement.vue?vue&type=style&index=0&id=56d8897b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports